import React from 'react'
import Index from '../_components/Invite/Index'
import SuperIndex from '../_components/Invite/SuperIndex'

//agency panel
const Invite = () => {
  return (
    <Index />
  )
}

//super admin panel users page
const SuperInvite = () => {
  return (
    <SuperIndex />
  )
}

export { Invite, SuperInvite }
